import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { Menu, ChevronDown } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Products', href: '/products' },
    { name: 'Solutions', href: '/solutions' },
    { name: 'Industries', href: '/industries' },
    { name: 'Plans', href: '/plans' },
    { name: 'Resources', href: '/resources' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="nav-header">
      <div className="container">
        <div className="flex items-center justify-between newh-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img
              src='/images/websiteLogo.webp'
              loading="eager"
              fetchpriority="high"
              alt="CXSquare Solutions"
              className="newhf-8 w-auto newmb-1"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navigation.slice(0, -1).map((item,i) => (
              <Link
                key={i}
                to={item.href}
                className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
              >
                {item.name}
              </Link>
            ))}

            {/* Resources Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className={`nav-link flex items-center ${isActive('/resources') || location.pathname.startsWith('/resources') || location.pathname === '/demo' || location.pathname === '/partner' || location.pathname === '/blog' ? 'active' : ''}`}>
                  Resources
                  <ChevronDown className="ml-1 h-4 w-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-slate-900 border-slate-700" align="end">
                <DropdownMenuItem asChild>
                  <Link to="https://stagecrm.cxsquare.solutions/" className="text-slate-300  cursor-pointer"> {/*  hover:text-blue-400 */}
                    login to GrowSquare
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/demo" className="text-slate-300  cursor-pointer"> {/*  hover:text-blue-400 */}
                    Request Demo
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/partner" className="text-slate-300 cursor-pointer">
                    Become a Partner
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/blog" className="text-slate-300 cursor-pointer">
                    Blog
                  </Link>
                </DropdownMenuItem>
                {/* <DropdownMenuItem asChild>
                  <Link to="/resources" className="text-slate-300 hover:text-blue-400 cursor-pointer">
                    All Resources
                  </Link>
                </DropdownMenuItem> */}
              </DropdownMenuContent>
            </DropdownMenu>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4">
            {/* <Link to="/demo" className="nav-link"> checkout?plan=2&billing=monthly
              Request Demo
            </Link> */}
            <Link to="/checkout?plan=Trial&billing=monthly">
              {/* < Link to="/contact"> */}
              <Button className="btn-primary">
                Start Free Trial
              </Button>
            </Link>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-slate-900 border-slate-800">
              <div className="flex flex-col space-y-4 mt-8">
                {navigation.map((item,i) => (
                  <Link
                    key={i}
                    to={item.href}
                    className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <div className="pt-4 border-t border-slate-800">
                  {/* <Link
                    to="/demo"
                    className="nav-link block mb-4"
                    onClick={() => setIsOpen(false)}
                  >
                    Request Demo
                  </Link> */}
                  <Link to="/checkout?plan=Trial&billing=monthly">
                    {/* < Link to="/contact"> */}
                    <Button className="btn-primary w-full" onClick={() => setIsOpen(false)}>
                      Start Free Trial
                    </Button>
                  </Link>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;